import api from '../services/apib'

class VersionService {
  getVersion() {
    return api.get('/version.json?_=' + Math.random())
  }
}

export default new VersionService()
